<template>
  <div class="illnessDesc">
    <a-drawer
      title="描述详情"
      placement="right"
      v-model:visible="visible"
      :width="420"
      :body-style="{ padding: '20px' }"
    >
      <div class="illnessDesc">
        <div class="title">病情描述</div>
        <div class="content">{{ props?.info?.descriptionContent || '暂无' }}</div>
        <div>
          <div class="title" style="margin-top: 11px">补充图片</div>
          <div style="margin-top: 11px" v-if="props?.info?.images">
            <a-image-preview-group>
              <div class="img-list">
                <div
                  v-for="(img, index) in JSON.parse(props.info.images)"
                  :key="index"
                  class="img-item"
                >
                  <a-image
                    :src="img"
                    :alt="`图片 ${index + 1}`"
                    class="preview-img"
                    preview="true"
                  />
                </div>
              </div>
            </a-image-preview-group>
          </div>
          <div class="content" v-else>暂无</div>
        </div>
        <!-- 上传时间 -->
        <div class="times">
          <div class="time-label">上传时间</div>
          <div class="time-label">{{ info?.addTime || '--' }}</div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>
<script setup>
import { ref, defineProps, defineExpose } from 'vue'
const visible = ref(false)
const props = defineProps({
  info: {
    type: Object,
    default: () => ({})
  }
})
const showDrawer = () => {
  visible.value = true
}
defineExpose({
  showDrawer
})
</script>

<style lang="scss" scoped>
.illnessDesc {
  .title {
    font-weight: bold;
    font-size: 16px;
    color: #1a1a1a;
  }
  .content {
    margin-top: 11px;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 1.5;
  }
  .img-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }
  .img-item {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    background: #f4f4f4;
    border: 1px solid #f0f0f0;
    width: 77px;
    height: 77px;
  }
  .times {
    margin-top: 11px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #333333;
    .time-label {
      color: #9e9e9e;
    }
  }
}
</style>
